module.exports = __webpack_public_path__ + "0bcab658bcc066e99fc36a4eb6ecc3b6.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/sweden.png
 ** module id = 678
 ** module chunks = 0
 **/